/**
 * Keys for a list of labels that may repeat: the label, suffixed with its
 * occurrence number from the second repeat on, so each key is stable per label.
 * @param {string[]} labels The labels.
 * @return {string[]} One unique key per label.
 */
export const occurrenceKeys = (labels: string[]): string[] => {
  const repeats = new Map<string, number>();
  const used = new Set<string>();
  return labels.map((label) => {
    let n = repeats.get(label) ?? 0;
    let key = n === 0 ? label : `${label}#${n}`;
    // A label can itself read like a numbered repeat ("A#1"), so skip taken keys.
    while (used.has(key)) {
      n += 1;
      key = `${label}#${n}`;
    }
    repeats.set(label, n + 1);
    used.add(key);
    return key;
  });
};
